<template>
  <div>
    <p>Thank you for your feedback.</p>
  </div>
</template>

<script>

  export default {
    name: 'FeedbackConfirmation'
  }
</script>
